import "../../styles/styles.css";
import { useState } from "react";
import { Container, Card, Nav } from "react-bootstrap";
import UserLayout from "../../components/custom/layouts/UserLayout";
import GstPurchaseInvoiceWiseReport from "../../components/report/GstPurchaseInvoiceWiseReport";
import GstPurchaseHsnReport from "../../components/report/GstPurchaseHsnReport";
import GstSalesReturnHsnReport from "../../components/report/GstSalesReturnHsnReport";
import GstPurchaseReturnInvoiceWiseReport from "../../components/report/GstPurchaseReturnInvoiceWiseReport";
import GstPurchaseReturnHsnReport from "../../components/report/GstPurchaseReturnHsnReport";

const GstPurchaseReport = () => {
  const [activeTab, setActiveTab] = useState("purchase-invoice");

  return (
    <UserLayout>
      <h3 className="mb-2 font-bold">GST Purchase Report</h3>

      <Container fluid className="p-4 shadow-lg bg-white rounded">
        <Nav
          variant="pills"
          className="custom-tabs mb-2 justify-content-start"
          activeKey={activeTab}
          onSelect={(selectedKey) =>
            setActiveTab(selectedKey || "purchase-invoice")
          }
        >
          <Nav.Item>
            <Nav.Link eventKey="purchase-invoice" className="custom-tab">
              GST Purchase Invoice Wise
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="purchase-hsn" className="custom-tab">
              GST Purchase HSN Wise
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="purchase-return-invoice" className="custom-tab">
              GST Purchase Return Invoice Wise
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="purchase-return-hsn" className="custom-tab">
              GST Purchase Return HSN Wise
            </Nav.Link>
          </Nav.Item>
          {/* <Nav.Item>
              <Nav.Link eventKey="customer" className="custom-tab">
                GST Customer Bill Wise
              </Nav.Link>
            </Nav.Item> */}
        </Nav>

        {/* Tab Content */}
        <Card className="tab-content-card">
          {activeTab === "purchase-invoice" && <GstPurchaseInvoiceWiseReport />}
          {activeTab === "purchase-hsn" && <GstPurchaseHsnReport />}
          {activeTab === "purchase-return-invoice" && (
            <GstPurchaseReturnInvoiceWiseReport />
          )}
          {activeTab === "purchase-return-hsn" && (
            <GstPurchaseReturnHsnReport />
          )}
          {/* {activeTab === "customer" && (
              <TabContent title="GST Customer Bill Wise" />
            )} */}
        </Card>
      </Container>
    </UserLayout>
  );
};

export default GstPurchaseReport;
